//@state
export interface cooperationState {
 
}

export const initialState: cooperationState = {
  
}
